import {
  BrowserRouter,
  Routes,
  Route,
  Link,
  useLocation,
  Navigate,
  Outlet,
} from "react-router-dom";
import HomePage from "./pages/HomePage";
import UserPage from "./pages/UserPage";
import SongRequestPage from "./pages/SongRequestPage";
import AddSongPage from "./pages/AddSongPage";
import TokenPage from "./pages/TokenPage";
import DevicePage from "./pages/DevicePage";
import PushNotificationPage from "./pages/PushNotificationPage";
import SongRequestByUserPage from "./pages/SongRequestByUserPage";
import PushNotificationForm from "./components/PushNotificationForm";
import DeviceLogPage from "./pages/DeviceLogPage";
import TestPage from "./pages/TestPage";
import PseudoIdPage from "./pages/PseudoIdPage";
import AddShortPage from "./pages/AddShortPage";
import AddHomebrewPlaylistPage from "./pages/AddHomebrewPlaylist";
import UserDevicePage from "./pages/UserDevicePage";
import ChangeSongPage from "./pages/ChangeSongPage";
import LoginPage from "./pages/LoginPage";
import AddSongNoYoutubePage from "./pages/AddSongNoYoutubePage";
import AddArtistPage from "./pages/AddArtistPage";
import SongRequestPage2 from "./pages/songRequest2/SongRequestPage2";
import MakingRequestPage from "./pages/MakingRequestPage";
import TestPage2 from "./pages/TestPage2";
import GuidePage from "./pages/GuidePage";
import AddSongYoutubePage from "./pages/AddSongYoutube";
import TestPage3 from "./pages/Test3/TestPage3";
import EditSongPage from "./pages/EditSongPage";
import BigQueryPage from "./pages/BigQuery/BigQueryPage";
import { useRecoilValue } from "recoil";
import { isAuthenticatedState } from "./atom/atom.auth";
import WelcomePage from "./pages/WelcomePage";
import TestPage4 from "./pages/TestPage4";
import 잡동사니Page from "./pages/잡동사니Page";
import TimerPage from "./pages/timer/TimerPage";
import PrivacyPolicyPage from "./pages/PrivatePolicyPage";
import OriginalSongPage from "./pages/OriginalSongPage";
import { useEffect, useState } from "react";
import PendingBrewingTransactionPage from "./pages/PendingBrewingTransactionPage";
import AttributionPage from "./pages/Attribution";

// SESSION_KEY 추가
const SESSION_KEY = "auth_session";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const isAuthenticated = useRecoilValue(isAuthenticatedState);
  const location = useLocation();
  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const sessionAuth = sessionStorage.getItem(SESSION_KEY);
      if (sessionAuth) {
        const session = JSON.parse(sessionAuth);
        if (session.isAuthenticated) {
          // 현재 경로 저장 (로그인 페이지가 아닌 경우에만)
          if (location.pathname !== "/admin/login") {
            sessionStorage.setItem("previousPath", location.pathname);
          }
        }
      }
      setIsInitializing(false);
    };

    checkAuth();
  }, [location.pathname]);

  if (isInitializing) {
    return null;
  }

  if (!isAuthenticated) {
    // 현재 경로 저장 (로그인 페이지가 아닌 경우에만)
    if (location.pathname !== "/admin/login") {
      sessionStorage.setItem("previousPath", location.pathname);
    }
    return (
      <Navigate
        to={`/admin/login${location.search}`}
        state={{ from: location }}
        replace
      />
    );
  }

  return <>{children}</>;
};

function Router() {
  const isAuthenticated = useRecoilValue(isAuthenticatedState);

  useEffect(() => {
    // 현재 쿼리스트링 저장
    const queryString = window.location.search;
    if (queryString) {
      localStorage.setItem("queryParams", queryString);
    }

    // 새로고침시 쿼리스트링 복원
    const savedQuery = localStorage.getItem("queryParams");
    if (savedQuery && window.location.search === "") {
      window.history.replaceState({}, "", savedQuery);
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<WelcomePage />} />
        <Route path="privacyPolicy" element={<PrivacyPolicyPage />} />

        <Route path="/admin">
          <Route path="login" element={<LoginPage />} />

          <Route
            index
            element={
              isAuthenticated ? (
                <Navigate to="/admin/guide" replace />
              ) : (
                <Navigate to="/admin/login" replace />
              )
            }
          />

          <Route element={<ProtectedAdminLayout />}>
            <Route path="guide" element={<GuidePage />} />
            <Route path="home" element={<HomePage />} />
            <Route path="user" element={<UserPage />} />
            <Route path="songRequest" element={<SongRequestPage />} />
            <Route path="songRequest2" element={<SongRequestPage2 />} />
            <Route path="makingRequest" element={<MakingRequestPage />} />
            <Route
              path="songRequestByUser"
              element={<SongRequestByUserPage />}
            />
            <Route path="addSong" element={<AddSongPage />} />
            <Route path="addSongYoutube" element={<AddSongYoutubePage />} />
            <Route path="addSongNoYoutube" element={<AddSongNoYoutubePage />} />
            <Route path="changeSong" element={<ChangeSongPage />} />
            <Route path="addShort" element={<AddShortPage />} />
            <Route path="addArtist" element={<AddArtistPage />} />
            <Route
              path="addHomebrewPlaylist"
              element={<AddHomebrewPlaylistPage />}
            />
            <Route path="token" element={<TokenPage />} />
            <Route path="originalSong" element={<OriginalSongPage />} />
            <Route path="device" element={<DevicePage />} />
            <Route path="pushNotification" element={<PushNotificationPage />} />
            <Route path="deviceLog" element={<DeviceLogPage />} />
            <Route path="bigQuery" element={<BigQueryPage />} />
            <Route path="test" element={<TestPage />} />
            <Route path="test2" element={<TestPage2 />} />
            <Route path="test3" element={<TestPage3 />} />
            <Route path="test4" element={<TestPage4 />} />
            <Route path="pseudo" element={<PseudoIdPage />} />
            <Route path="userDevice" element={<UserDevicePage />} />
            <Route path="editSong" element={<EditSongPage />} />
            <Route path="originalSong" element={<OriginalSongPage />} />
            <Route
              path="pendingBrewingTransaction"
              element={<PendingBrewingTransactionPage />}
            />
            <Route path="잡동사니" element={<잡동사니Page />} />
            <Route path="attribution" element={<AttributionPage />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const ProtectedAdminLayout = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isTester = queryParams.get("isTester") === "True";

  return (
    <ProtectedRoute>
      <div style={{ display: "flex" }}>
        {!isTester && (
          <nav
            style={{
              width: "200px",
              position: "fixed",
              height: "100vh",
              backgroundColor: "#f4f4f4",
              padding: "20px",
            }}
          >
            <ul
              style={{
                listStyleType: "none",
                padding: 0,
                width: "100%",
                maxHeight: "40%",
                overflow: "scroll",
              }}
            >
              <li style={{ marginBottom: "10px" }}>
                <p>현재 환경 : {process.env.REACT_APP_ENV}</p>
              </li>
              {/* <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/pushNotification">알림 보내기</Link>
              </li> */}
              {/* <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/guide">가이드</Link>
              </li> */}
              {/* <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/home">노래 전체</Link>
              </li> */}
              <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/잡동사니">잡동사니</Link>
              </li>
              <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/originalSong">원곡</Link>
              </li>
              <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/songRequest2">[New] 신청곡</Link>
              </li>
              <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/makingRequest">[New] 제조중</Link>
              </li>
              <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/addSong">노래 추가(유튜브 x)</Link>
              </li>
              <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/addSongYoutube">노래 추가(유튜브 O)</Link>
              </li>
              {/* <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/addSongNoYoutube">추가 : 노래(유튜브x)</Link>
              </li> */}
              {/* <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/songRequestByUser">신청곡</Link>
              </li> */}
              {/* <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/addArtist">추가 : 아티스트</Link>
              </li> */}
              {/* <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/addHomebrewPlaylist">추가 : 홈브루 플리</Link>
              </li> */}
              {/* <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/bigQuery">빅쿼리</Link>
              </li> */}
              {/* <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/changeSong">노래 전체 및 수정</Link>
              </li> */}
              {/* <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/userDevice">유저&디바이스</Link>
              </li>
              <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/addShort">추가 : 쇼츠</Link>
              </li> */}
              <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/user">User</Link>
              </li>
              <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/device">Device</Link>
              </li>
              <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/pendingBrewingTransaction">
                  PendingBrewingTransaction
                </Link>
              </li>
              <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/test">Test</Link>
              </li>
              {/* <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/token">Token</Link>
              </li>
              <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/deviceLog">DeviceLog</Link>
              </li>
              <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/test">Test</Link>
              </li>
              <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/test2">Test2</Link>
              </li>
              <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/test3">Test3</Link>
              </li> */}
              <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/test4">Test4</Link>
              </li>
              <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/editSong">노래 전체 및 수정</Link>
              </li>
              <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/pseudo">Pseudo</Link>
              </li>
              <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/attribution">Attribution</Link>
              </li>
              {/* <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/songRequest">Song Request</Link>
              </li>
              <li style={{ marginBottom: "10px" }}>
                <Link to="/admin/login">로그인</Link>
              </li> */}
              <li style={{ position: "absolute", bottom: 40 }}>
                <PushNotificationForm />
              </li>
            </ul>
          </nav>
        )}
        <div
          style={{
            marginLeft: isTester ? "0" : "220px",
            padding: "20px",
            width: "100%",
          }}
        >
          <Outlet />
        </div>
      </div>
    </ProtectedRoute>
  );
};

export default Router;
